"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _reduxForm = require("redux-form");

var _addressSettingsFormValidation = require("utils/addressSettingsFormValidation");

var _paymentFormValidation = require("utils/paymentFormValidation");

var _recompose = require("recompose");

var _AddressSettingFields = require("./AddressSettingFields");

var _AddressSettingFields2 = _interopRequireDefault(_AddressSettingFields);

var _euCountries = require("@quixeltools/quixel-ui-library/dist/utils/euCountries");

var _euCountries2 = _interopRequireDefault(_euCountries);

var _countryStateCodes = require("../../utils/countryStateCodes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isEUCountry = _ramda2.default.contains(_ramda2.default.__, _euCountries2.default);

var AddressSettingsFormContainer = function AddressSettingsFormContainer(props) {
  var _props$address = props.address,
      stateList = _props$address.stateList,
      loaded = _props$address.loaded,
      loadError = _props$address.error,
      loading = _props$address.loading;


  var cities = [];
  var states = [];

  if (stateList) {
    states = stateList.map(function (state) {
      return {
        name: state.name,
        value: state.name,
        code: state.code
      };
    });
    if (props.fields.state.value) {
      var list = stateList.find(function (state) {
        return state.name === props.fields.state.value;
      });
      if (list && list.cities) {
        cities = list.cities.map(function (city) {
          return {
            name: city,
            value: city
          };
        });
      }
    }
  }

  return _react2.default.createElement(_AddressSettingFields2.default, {
    paypalContainerId: props.paypalContainerId,
    fields: props.fields,
    error: props.errorMsg,
    message: props.message,
    handleSubmit: props.handleSubmit,
    updating: props.updating,
    lockCountryAndVat: false,
    validatingVat: false,
    stateList: props.fields.country.value === "IN" ? (0, _countryStateCodes.getIndiaStates)() : states,
    citiesList: states && cities,
    loaded: !loading && !loadError,
    onChangeCountryHandler: function onChangeCountryHandler() {
      if (props.fields.country.value === "US" || props.fields.country.value === "CA") {
        props.validatePostalCode({
          countryCode: "",
          postalCode: ""
        });
      }
    }
  });
};

exports.default = (0, _reduxForm.reduxForm)({
  fields: ["name", "company", "address", "postalCode", "city", "country", "vatNo", "state", "address2", "validatingField", "isPromoCodeValid", "mainDivision", "promoCode"],
  form: "Address Settings",
  asyncValidate: _paymentFormValidation.asyncValidate,
  asyncBlurFields: ["postalCode", "vatNo", "validatingField"],
  validate: _addressSettingsFormValidation.validate
})((0, _recompose.lifecycle)({
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var _this = this;

    if (this.props.fields.country.value !== nextProps.fields.country.value) {
      if (nextProps.fields.country.value === "US" || nextProps.fields.country.value === "CA") {
        this.props.validatePostalCode({
          postalCode: "",
          countryCode: nextProps.fields.country.value
        });
      }

      if (nextProps.fields.country.value === "IN") {
        var indiaStateList = (0, _countryStateCodes.getIndiaStates)();
        var indiaState = indiaStateList && indiaStateList.find(function (x) {
          return x !== undefined;
        });
        this.props.fields.state.onChange(indiaState.name);
        this.props.fields.mainDivision.onChange(indiaState.code);
      } else {
        this.props.fields.state.onChange("");
        this.props.fields.mainDivision.onChange("");
      }
      this.props.fields.city.onChange("");
      this.props.fields.postalCode.onChange("");
    }
    if (nextProps.address !== this.props.address) {
      var stateList = nextProps.address.stateList;


      if (stateList) {
        var state = stateList.find(function (st) {
          return st.name.toLowerCase() === _this.props.fields.state.value.toLowerCase();
        });
        if (state) {
          this.props.fields.mainDivision.onChange(state.code);
          var cities = state.cities;


          var existingCity = cities && cities.find(function (x) {
            return x === _this.props.fields.city.value;
          });
          if (existingCity) {
            this.props.fields.city.onChange(existingCity);
          } else {
            var city = cities && cities.find(function (x) {
              return x !== undefined;
            });
            this.props.fields.city.onChange(city);
          }
        } else {
          var firstItem = stateList && stateList.find(function (x) {
            return x !== undefined;
          });
          if (firstItem) {
            this.props.fields.state.onChange(firstItem.name);
            this.props.fields.mainDivision.onChange(firstItem.code);
            var _cities = firstItem.cities;

            var _city = _cities && _cities.find(function (x) {
              return x !== undefined;
            });
            if (_city) {
              this.props.fields.city.onChange(_city);
            }
          } else {
            this.props.fields.state.onChange("");
            this.props.fields.city.onChange("");
          }
        }
      }
    }
  }
})(AddressSettingsFormContainer));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AddressSettingsForm/AddressSettingsForm.jsx
// module id = 2822
// module chunks = 0